function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.31249 0H12.4641L18.375 5.88789V19.6875C18.375 20.4126 17.787 21 17.0625 21H1.31249C0.587968 21 0 20.4126 0 19.6875V1.31249C0 0.587357 0.588036 0 1.31249 0Z",
  fill: "#E2574C"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.356 5.90631H13.7812C13.0567 5.90631 12.4688 5.31834 12.4688 4.59382V0.0131836L18.356 5.90631Z",
  fill: "#B53629"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4511 9.95066C13.671 9.95066 13.7786 9.75904 13.7786 9.57333C13.7786 9.38103 13.6664 9.19531 13.4511 9.19531H12.199C11.9542 9.19531 11.8177 9.39807 11.8177 9.62188V12.699C11.8177 12.9733 11.9739 13.1256 12.1852 13.1256C12.3952 13.1256 12.5521 12.9733 12.5521 12.699V11.8544H13.3094C13.5443 11.8544 13.6618 11.6621 13.6618 11.4712C13.6618 11.2842 13.5443 11.0984 13.3094 11.0984H12.5521V9.95066H13.4511ZM9.21895 9.19531H8.30281C8.05408 9.19531 7.87753 9.36595 7.87753 9.61923V12.7017C7.87753 13.016 8.13149 13.1144 8.31326 13.1144H9.2747C10.4126 13.1144 11.164 12.3657 11.164 11.21C11.1634 9.98807 10.456 9.19531 9.21895 9.19531ZM9.26295 12.3545H8.70445V9.95528H9.20781C9.96975 9.95528 10.3011 10.4665 10.3011 11.172C10.3011 11.8322 9.97559 12.3545 9.26295 12.3545ZM5.90687 9.19531H4.99928C4.74268 9.19531 4.59961 9.36459 4.59961 9.62188V12.699C4.59961 12.9733 4.76366 13.1256 4.98414 13.1256C5.20462 13.1256 5.36867 12.9733 5.36867 12.699V11.8006H5.93763C6.63981 11.8006 7.21929 11.3031 7.21929 10.5032C7.21936 9.72033 6.66025 9.19531 5.90687 9.19531ZM5.89179 11.0788H5.36874V9.91786H5.89179C6.21467 9.91786 6.42008 10.1698 6.42008 10.4986C6.4194 10.8268 6.21467 11.0788 5.89179 11.0788Z",
  fill: "white"
});
function SvgFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.2bf9fae744974a9af6c2ff142c2b9431.svg";
export { ForwardRef as ReactComponent };